<template>
  <div class="c-table">
    <div v-for="(type, key, tableIndex) in table" :key="'tabletype-' + key">
      <div class="c-collapsible" :class="{ '-border-top': tableIndex === 0 }">
        <h3 class="-no-style c-collapsible__button">
          <b v-html="$store.state.lang === 'de' ? getColorName(key) : key"></b>
        </h3>
        <div class="c-collapsible__content">
          <div
            class="c-table__grid"
            :style="{
              'grid-template-columns':
                'repeat(' + tableheader.length + ', auto)',
            }"
          >
            <!-- <div> -->
            <!-- <div class="row c-tableheader py-3"> -->
            <div
              class="c-table__tableheader"
              :class="classes[key]"
              v-for="(entry, key) in tableheader"
              :key="key"
            >
              {{ entry }}
            </div>
            <!-- </div> -->
            <div class="c-line"></div>
            <template v-for="(row, rowIndex) in type">
              <div
                :class="[
                  { 'c-popover': colIndex === 0 && checkBeamAngles(row[1]) },
                  { 'u-whitespace-nowrap': colIndex === 0 || col.length < 7 },
                  ...classes[colIndex],
                ]"
                v-for="(col, colIndex) in row"
                :key="key + rowIndex + '-tablecol-' + colIndex"
              >
                <div
                  class="c-popover__box"
                  v-if="colIndex === 0 && checkBeamAngles(row[1])"
                >
                  <!-- <div class="row no-gutters">
                    <div class="col-4">
                      <img :src="imageurl + 'reflector.png'" />
                    </div>
                    <div class="col-8"> -->
                  <table class="u-text-center">
                    <tr>
                      <th class="px-5"></th>
                      <th class="px-3">Code</th>
                      <th class="px-3">Abstrahlwinkel</th>
                    </tr>
                    <tr
                      v-for="(beamAngle, beamAngleIndex) in beamAngles[
                        tableBeamAngles[key][rowIndex]
                      ]"
                    >
                      <td
                        v-if="beamAngleIndex === 0"
                        :rowspan="
                          beamAngles[tableBeamAngles[key][rowIndex]].length
                        "
                      >
                        <img :src="imageurl + 'reflector.png'" />
                      </td>
                      <td class="px-3">
                        <span
                          v-html="
                            col.split('-')[0] +
                              (col.split('-')[2]
                                ? '-' + col.split('-')[1]
                                : '') +
                              '-'
                          "
                        ></span>
                        <span class="c-popover__code">{{
                          beamAngle.angle.length < 2
                            ? "0" + beamAngle.angle
                            : beamAngle.angle
                        }}</span>
                      </td>
                      <td class="px-3">
                        {{ beamAngle.angle }}° {{ beamAngle.addition }}
                      </td>
                    </tr>
                  </table>

                  <!-- </div>
                  </div> -->
                </div>
                <span v-html="col"></span>
                <img
                  v-if="colIndex === 0 && checkBeamAngles(row[1])"
                  class="c-table__caret"
                  :src="root + 'resources/img/caret_down.svg'"
                />
              </div>
            </template>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      required: true,
      type: Object,
    },
    tableheader: {
      required: true,
      type: Array,
    },
    beamAngles: {
      required: true,
      type: Object,
    },
    colorNamesMapping: {
      required: true,
      type: Object,
    },
    classes: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      tableBeamAngles: {},
      imageurl: process.env.VUE_APP_IMAGEURL,
      root: process.env.VUE_APP_ROOT,
    };
  },
  created() {
    for (const ledModule in this.beamAngles) {
      for (const tableKey in this.table) {
        for (const [index, row] of this.table[tableKey].entries()) {
          if (row[1].includes(ledModule)) {
            if (!this.tableBeamAngles[tableKey]) {
              this.tableBeamAngles[tableKey] = {};
            }
            this.tableBeamAngles[tableKey][index] = ledModule;
          }
        }
      }
    }
  },
  methods: {
    checkBeamAngles(text) {
      for (const ledModule in this.beamAngles) {
        if (text.includes(ledModule)) {
          return true;
        }
      }
      return false;
    },
    getColorName(key) {
      const keyArray = key.split("&nbsp;&nbsp;");
      // console.log(keyArray);
      for (const [index, keyPart] of keyArray.entries()) {
        if (this.colorNamesMapping[keyPart]) {
          keyArray[index] = this.colorNamesMapping[keyPart];
        }
      }
      return keyArray.join("&nbsp;&nbsp;");
    },
  },
};
</script>

<style lang="scss" scoped>
// .c-tableheader {
//     text-transform: uppercase;
//     font-weight: bold;
//     border-bottom: 1px solid $grey-dark;
// }

// .c-collapsible__content {
//   @include media-breakpoint-down(xs) {
//     padding-left: 8px;
//     padding-right: 8px;
//     font-size: 12px;
//   }
// }
.c-table {
  &__grid {
    display: grid;
    // grid-template-columns: repeat(5, 1fr);
    column-gap: 10px;
    // padding: 20px 0px;
    > div {
      padding: 10px 0px 10px 0;
    }
  }
  &__tableheader {
    // border-bottom: 1px solid $grey-dark;
    // text-transform: uppercase;
    font-weight: bold;
    // padding-bottom: 10px;
  }
  &__caret {
    margin: 0 10px;

    @include media-breakpoint-down(xs) {
      display: block !important;
      margin: auto;
    }
  }
}
</style>
